import React from 'react';
import styles from './privacyPopup.module.scss';
import CustomIcon from '@/components/ui/CustomIcon';

interface PrivacyPopupProps {
  onClose: () => void;
  primaryColor?: string;
  secondaryColor?: string;
}

const PrivacyPopup: React.FC<PrivacyPopupProps> = ({ onClose, primaryColor, secondaryColor }) => {
  return (
    <div className={styles['privacy-popup']} style={{ '--primary-color': primaryColor, '--secondary-color': secondaryColor } as React.CSSProperties}>
      <div className={styles['privacy-popup__content']}>
        <p>
          Tus mensajes serán tratados por Soluciones Cuatroochenta, S. A, para responder a tus consultas mediante un asistente de IA para mejorar el servicio, analizando de forma agregada el uso del chatbot. No aportes datos sensibles ni información personal innecesaria. Puedes ejercer tus derechos y consultar más detalles en nuestra <a href="https://cuatroochenta.com/politica-de-privacidad/" target="_blank" rel="noopener noreferrer">Política de Privacidad</a>
        </p>
        <div className={styles['privacy-popup__actions']}>
          <button className={styles['privacy-popup__accept']} onClick={onClose}>
            Aceptar
          </button>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPopup;
